import register from '@kpsys/angularjs-register';
import {ModalDialogService} from './modal-dialog.service';

export default register('portaro.modal-dialogs')
    .service(ModalDialogService.serviceName, ModalDialogService)
    .name()